import React from 'react';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/Button';
import cx from 'classnames';
import messages from '../../../../locale/messages';
import CurrencyConverter from "../../../CurrencyConverter/CurrencyConverter";
import { openHeaderModal } from '../../../../actions/siteadmin/modalActions';
import { api, subCategoryUploadDir } from '../../../../config';
import increment from '../../../../../public/Icons/increment.png';
import decrement from "../../../../../public/Icons/decrement.png"
import { AngleDownArrowIcon } from '../../../Common/Assets/SVGIcon/CommonSvgIcon';
import bt from '../../../commonStyle.css';
import s from './ViewSubCategory.css';

const ViewSubCategory = ({
    image,
    name,
    description,
    data,
    pricingType,
    basePrice,
    currency,
    multiplierValue,
    isOrderExist,
    quantity,
    handleAddOrder,
    handleRemoveOrder,
    addOrderQuantity,
    removeOrderQuantity,
    preferredCurrency,
    openHeaderModal,
    location,
    intl: { formatMessage },
}) => {
    const isDisabled = multiplierValue <= quantity;
    const isAdd = quantity <= 0;
    const isRemove = quantity === 1;

    const handleAddClick = (isAdd) => {
        const subcategoryData = {
            categoryId: data?.categoryId,
            subCategoryId: data?.id,
            totalQuantity: pricingType === 'fixed' ? multiplierValue : 0,
            minimumHours: pricingType === 'hourly' ? multiplierValue : 0,
            currency: preferredCurrency,
            quantity: isAdd ? 1 : 0,
            dropLocation: location?.location?.label,
            dropLat: location?.location?.lat,
            dropLng: location?.location?.lng,
            // Display-only fields so the logged-out guest review screen can show each line
            // (name / photo / unit price) without a round-trip. addOrderWhole ignores these.
            name,
            image,
            basePrice,
            pricingType,
            multiplierValue,
        };
        handleAddOrder(subcategoryData);
    };
    let formData = {
        name, description
    }
    return (
        <>
            <div className={s.viewSubCategoryItemImgContainer}>
                <img src={`${api.apiEndpoint}${subCategoryUploadDir}medium_${image}`} alt={name || ''} />
            </div>
            <div className={s.viewSubCategoryItemInfoContainer}>
                <div className={s.viewSubCategoryItemInfoTitle}>{name}</div>
                <div className={s.viewSubCategoryItemInfoDesc}>
                    {
                        pricingType === 'fixed' ? (
                            <>
                                <span><FormattedMessage {...messages.maxQuantityLabel} />&nbsp;</span>
                                <span>{multiplierValue}</span>
                            </>
                        ) : (
                            <>
                                <span><FormattedMessage {...messages.minHourLabel} />&nbsp;</span>
                                <span>{multiplierValue}&nbsp;</span>
                                <span><FormattedMessage {...messages.hoursLabel} /></span>
                            </>
                        )
                    }
                </div>
                <div className={s.viewSubCategoryItemInfoSpecialText}>
                    <CurrencyConverter amount={basePrice} from={currency} />
                    <span>&nbsp;{'/'}&nbsp;</span>
                    {
                        pricingType === 'fixed' ? (
                            <span><FormattedMessage {...messages.quantityText} /></span>
                        ) : (
                            <span><FormattedMessage {...messages.hourLabel} /></span>
                        )
                    }
                </div>
                <div className={s.viewSubCategoryItemInfoLink}>
                    <div onClick={() => openHeaderModal('jobDescription', formData)} className={bt.commonLinkWithIcon}>
                        <FormattedMessage {...messages.jobDescription} />
                        <AngleDownArrowIcon />
                    </div>
                </div>
                {
                    pricingType === 'fixed' ? (
                        <div>
                            {(!isOrderExist || isAdd) && <Button onClick={() => handleAddClick(true)} className={cx(bt.btnPrimary, bt.widthFull)}>{formatMessage(messages.add)}</Button>}
                            {
                                isOrderExist && !isAdd && <div className={s.viewSubCategoryRangeBtn}>
                                    <span className={s.viewSubCategoryRangeBtnIcon} onClick={() => isRemove ? handleRemoveOrder(data?.id) : removeOrderQuantity({ id: data?.id, categoryId: data?.categoryId })}>
                                        <img src={decrement} alt="decrementIcon" />
                                    </span>
                                    {quantity}
                                    <span className={cx(s.viewSubCategoryRangeBtnIcon, { [s.viewSubCategoryRangeDisabledBtnIcon]: isDisabled })} onClick={() => !isDisabled && addOrderQuantity({ id: data?.id, categoryId: data?.categoryId })}>
                                        <img src={increment} alt="incrementIcon" />
                                    </span>
                                </div>
                            }
                        </div>
                    ) : (
                        <Button className={cx(bt.btnPrimary, bt.widthFull)} onClick={() => isOrderExist ? handleRemoveOrder(data?.id) : handleAddClick(true)}>
                            {formatMessage(messages[isOrderExist ? 'remove' : 'add'])}
                        </Button>)
                }
            </div >
        </>
    );
};
const selector = formValueSelector('LocationSearchForm');
const mapState = (state) => ({
    preferredCurrency: state?.userAccount?.data?.preferredCurrency,
    location: selector(state, 'location'),
});
const mapDispatch = {
    openHeaderModal
}
export default compose(
    injectIntl, withStyles(bt, s),
    connect(mapState, mapDispatch)
)(ViewSubCategory);


